import { v4 as uuidv4 } from 'uuid';

const Wishlist = (function (window, $) {

    const cookieKey = 'wpg_wishlist';

    function Wishlist() {
        this.tabButtonsWrap = $('.book-tab-buttons');
        this.tabButtons = this.tabButtonsWrap.find('a');
        this.tabContent = $('.tab-content > div');

        this.$wishlistIcons = $('.icon-wishlist');
        this.$headerIcon = $('a.icon-heart');

        // below var(s) are found outside the wishlist icon element
        this.$productSummary = $('.section-wishlist-product-details');
        this.$totalWishlistItems = $('.total-wishlist-items');

        this.id = this.retrieveWishlistId(); // Get from cookie 
        this.items = [];
        if (this.id) {
            // Wishlist present, get the content (fires update)
            this.getItems();
        } else {
            // No whislist(cookie), continue with empty items
            this.update();
        }
        this.addEvents();
    }

    /**
     * Update interface and button states
     */
    Wishlist.prototype.update = function () {
        let _this = this;
        this.$wishlistIcons.each(
            function() {
                let $current = $(this);
                let ean = $current.data('wishlist-ean').toString();
                let inWishlist = _this.inWishlist(ean);

                if(inWishlist) {
                    $current.find('.icon-heart').addClass('active');
                } else {
                    $current.find('.icon-heart').removeClass('active');
                }
            }
        );

        this.$headerIcon.html('');
        if(this.items.length > 0) {
            let badge = $('<span class="cart-badge no-of-products" />').appendTo(this.$headerIcon);
            badge.html(this.items.length);
        }
    };

    Wishlist.prototype.addEvents = function () {
        this.$wishlistIcons.on('click', this.toggleItem.bind(this));

        if(this.$productSummary.length > 0) {
            this.$wishlistIcons.on('click', this.removeCardFromWishlist.bind(this));
            this.$wishlistIcons.on('click', this.updateTotalNoItems.bind(this));
        }
    };

    Wishlist.prototype.retrieveWishlistId = function () {
        var cookieValue = document.cookie.match('(^|;) ?' + cookieKey + '=([^;]*)(;|$)');
        return cookieValue ? cookieValue[2] : null;
    }

    Wishlist.prototype.generateNewWishlistId = function () {
        this.id = uuidv4();
        var expires = new Date();
        expires.setTime(expires.getTime() + (20 * 365 * 24 * 60 * 60 * 1000)); // Make it long living
        document.cookie = cookieKey + '=' + this.id + ';expires=' + expires.toUTCString() + ";path=/";
    }

    /**
     * get active button for Enhanced Ecommerce event
     *
     * @param {string} ean 
     * @returns {Object}
     */
    Wishlist.prototype.getActiveButton = function (ean) {
        let activeButton;

        // Some bookpages don't have book tab switches. See VER-4421
        if (this.tabButtons.length === 0) { 
            activeButton = this.tabContent.find('[data-add-to-cart="' + ean + '"]');
        } else {
            activeButton = this.tabButtonsWrap.find('[data-ean="' + ean + '"]');
        }
        
        return activeButton;
    }

    Wishlist.prototype.addItem = function (ean) {
        this.updateItems(
            {
                'wishlist_ean': ean,
                'action': 'wishlist_add'
            }
        );

        let button = this.getActiveButton(ean);
        let product = Events.createProduct(button, {
            item_id: ean
        });
        Events.fireEcommerceEvent('items', product, 'ecommerce_add_to_wishlist');

    }

    Wishlist.prototype.removeItem = function (ean) {
        this.updateItems(
            {
                'wishlist_ean': ean,
                'action': 'wishlist_remove'
            }
        );

        let button = this.getActiveButton(ean);
        let product = Events.createProduct(button, {
            item_id: ean,
         });
        Events.fireEcommerceEvent('items', product, 'ecommerce_remove_from_wishlist');
    }

    Wishlist.prototype.getItems = function () {
        this.updateItems(
            {
                'action': 'wishlist_get'
            }
        );
    }

    /**
     * Remove the card from the wishlist page so no confusion will exist about the existence of the item in the wishlist 
     */
    Wishlist.prototype.removeCardFromWishlist = function (e) {
        e.target.parentElement.closest('article').remove();
    }

    /**
     * Update total number of items stated on the wishlist page when an item on the wishlist page is removed
     */
    Wishlist.prototype.updateTotalNoItems = function() {
        let totalNumber = this.$totalWishlistItems.text();
        let getNumber = parseFloat(totalNumber);

        this.$totalWishlistItems.text(getNumber -1 + " items");
    }

    Wishlist.prototype.inWishlist = function (ean) {
        let itemByEan = this.items.find(item => item.ean == ean);
        return typeof itemByEan !== 'undefined';
    }

    Wishlist.prototype.toggleItem = function (e) {

        e.preventDefault();

        let $target = $(e.currentTarget);
        let ean = $target.data('wishlist-ean').toString();

        if (this.inWishlist(ean)) {
            this.removeItem(ean);
        } else {
            this.addItem(ean);
        }
    }

    /**
     * Call wishlist api and reflect result in items and ui
     */
    Wishlist.prototype.updateItems = function (params) {

        // Prevent double requests
        if (this.xhr) {
            this.xhr.abort();
        }

        if (!this.id) {
            this.generateNewWishlistId();
        }
        params.wishlist_id = this.id;

        this.xhr = $.ajax(window.ajaxURL, {
            type: 'POST',
            data: params,
            dataType: 'json',
        }).done(function (data) {
            this.items = data;
            this.update();
        }.bind(this));

    };

    return Wishlist;

}(window, jQuery));

export { Wishlist };